module.exports = {
  '@primary-color': '#f38633',
  '@link-color': '#8',
  '@redMain': '#8',
  '@greyDark': '#454545',
};
